!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    var n = t();

    for (var r in n) {
      ("object" == typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 3);
  }([function (e, t) {
    e.exports = require("@babel/runtime/helpers/defineProperty");
  }, function (e, t) {
    e.exports = require("@babel/runtime/helpers/classCallCheck");
  }, function (e, t) {
    e.exports = require("core-js/es/string/starts-with");
  }, function (e, t, n) {
    "use strict";

    n.r(t);

    var r = n(0),
        o = n.n(r),
        c = n(1),
        i = n.n(c),
        a = function a(e) {
      var t = document.querySelector("meta[name=json-".concat(e, "]")).getAttribute("content");

      try {
        return JSON.parse(t);
      } catch (e) {
        return t;
      }
    },
        s = function s() {
      try {
        return document.cookie.match(/_ga=(.+?);/)[1].split(".").slice(-2).join(".");
      } catch (e) {
        return;
      }
    },
        u = function u() {
      try {
        var e = document.cookie.match("optimizelyEndUserId=([^;]*)");
        return e ? e[1] : "";
      } catch (e) {
        return "";
      }
    },
        l = function l(e) {
      var t = 0,
          n = (t = -(t = void 0 === e ? new Date().getTimezoneOffset() / 60 : e / 60)) >= 0 ? "+" : "-";
      t = Math.abs(t);
      var r = Math.floor(t);
      r < 10 && (r = "0".concat(r));
      var o = t % 1;
      0 === o ? o = "0".concat(o) : o *= 60;
      var c = "UTC".concat(n).concat(r, ":").concat(o);
      return {
        timeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timeZone: c
      };
    };

    n(2);

    function d(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function f(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? d(Object(n), !0).forEach(function (t) {
          o()(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    n.d(t, "default", function () {
      return g;
    });

    var g = function e(t) {
      var n = this,
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      i()(this, e), this._inject = function () {
        var e = document.createElement("script");
        e.innerHTML = '\n      // This snippet is copied from https://segment.com/docs/sources/website/analytics.js/quickstart/\n      !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";\n      analytics.load(\''.concat(n._writeKey, "');\n      }}();"), document.head.appendChild(e), n._hasSegmentLoaded();
      }, this._hasSegmentLoaded = function () {
        n._retryCount += 1, n._retryCount > n._retryMax || (window.analytics ? (window.pdAnalytics = n, n._isLoaded = !0, n._resolve(n)) : setTimeout(n._hasSegmentLoaded, 200));
      }, this.setDebugMode = function (e) {
        n._debug = e, e ? (window.sessionStorage.setItem("pd-debug-segment", !0), console.log("Segment is now in debug mode and events will only be console logged.")) : window.sessionStorage.removeItem("pd-debug-segment");
      }, this.isLoaded = function () {
        return n._isLoaded;
      }, this._setEnvironment = function () {
        var e = n._shouldTrack(),
            t = window.sessionStorage.getItem("pd-debug-segment") || !1;

        !1 !== e && "true" !== t || n.setDebugMode(!0);
      }, this._shouldTrack = function () {
        var e = window.location.href.includes(".pagerduty.com"),
            t = n._currentUser.isSpoofed() || n._currentUser.isSafeSpoofing || !1,
            r = n._currentUser.email.includes("pagerduty.com") || !1,
            o = window.location.hostname.split(".")[0],
            c = o.startsWith("pdt-") || !1,
            i = "pdt-circular" === o || !1,
            a = !!(n._accountFeatures && n._accountFeatures.length > 0) && -1 !== n._accountFeatures.indexOf("test_mode");

        return !(!e || t || a || c && !i || r && !i);
      }, this._getMetaTagFeData = function () {
        var e = a("current_user"),
            t = a("current_account"),
            n = a("account_features");
        return !!(Object.getOwnPropertyNames(e).length > 0 && Object.getOwnPropertyNames(t).length > 0 && Object.getOwnPropertyNames(n).length > 0) && {
          currentUser: e,
          currentAccount: t,
          accountFeatures: n
        };
      }, this._delay = function (e) {
        setTimeout(e(), n._timeout);
      }, this.getAnonymousId = function () {
        if (window.analytics) return window.analytics.user().anonymousId();
      }, this.identify = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = arguments.length > 1 ? arguments[1] : void 0,
            r = f({}, e),
            o = l();
        r.name = n._currentUser.name, r.Email = n._currentUser.email, r.email = n._currentUser.email, r.Title = n._currentUser.jobTitle, r.Role = n._currentUser.role, r["Created At"] = n._currentUser.created_at, r["Account Name"] = n._currentAccount.name, r["Sub Domain"] = n._currentAccount.subdomain, r["Account Created At"] = n._currentAccount.created_at, r["Account Plan"] = n._currentAccount.plan, r["Account State"] = n._currentAccount.state, r.timezone_name = o.timeZoneName, r.timezone = o.timeZone, r.ga_clientid = s(), r.groupId = n._currentAccount.id, r.optimizelyEndUserId = u(), r.schedulesCount = n._currentAccount.schedules_count, r.escalationPoliciesCount = n._currentAccount.escalation_policies_count, r.fullUserCount = n._currentAccount.users_count, n._debug ? (console.log("Segment Group", r.groupId), console.log("Segment Identify", n._currentUser.id, r)) : window.analytics && (window.analytics.group(r.groupId), window.analytics.identify(n._currentUser.id, r)), t && n._delay(t);
      }, this.track = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 ? arguments[2] : void 0,
            o = f({}, t);
        o.groupId = n._currentAccount.id, n._debug ? console.log("Segment Track", e, o) : window.analytics && window.analytics.track(e, o), r && n._delay(r);
      }, this.page = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 ? arguments[2] : void 0,
            o = f({}, t);
        o.groupId = n._currentAccount.id, n._debug ? console.log("Segment Page", e, o) : window.analytics && window.analytics.page(e, o), r && n._delay(r);
      }, this.group = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 ? arguments[2] : void 0;
        n._debug ? console.log("Segment Group", e, t) : window.analytics && window.analytics.group(e, t), r && n._delay(r);
      }, this.trackForm = function () {
        return !1;
      }, this._writeKey = t, this._currentUser = r, this._currentAccount = o, this._accountFeatures = c.features, this._isLoaded = !1, this._debug = !1, this._timeout = 500, this._retryCount = 0, this._retryMax = 15, this._promise = new Promise(function (e, t) {
        n._resolve = e, n._reject = t;
      });
      var d = Object.getOwnPropertyNames(r).length > 0 && Object.getOwnPropertyNames(o).length > 0 && Object.getOwnPropertyNames(c).length > 0;

      if (!d) {
        var g = this._getMetaTagFeData();

        if (!1 === g) throw new Error("Segment library cannot retrieve frontend data.");
        this._currentUser = g.current_user, this._currentAccount = g.current_account, this._accountFeatures = g.account_features.features;
      }

      return this._setEnvironment(), this._inject(), this._promise;
    };
  }]);
});